import { Button, HStack } from '@chakra-ui/react';
import React from 'react';

import { generatePaginationOptions } from './pagination.utils';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onSelectPage: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  onSelectPage,
}) => {
  const paginationOptions = generatePaginationOptions(currentPage, totalPages);

  return (
    <HStack spacing={2}>
      {paginationOptions.map((option, index) => (
        <Button
          key={index}
          variant="link"
          color="blue.800"
          onClick={
            typeof option === 'number' ? () => onSelectPage(option) : undefined
          }
          isDisabled={typeof option !== 'number' || option === currentPage}
        >
          {option}
        </Button>
      ))}
    </HStack>
  );
};

export default Pagination;
